export const environment = {
  supabaseUrl: 'https://rchawechrgxucsqapjoq.supabase.co',
  supabaseKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJjaGF3ZWNocmd4dWNzcWFwam9xIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzIzNjA5NDEsImV4cCI6MjA0NzkzNjk0MX0.kw-oRr-NssqUH-xB1uIl2gyI7NR2M8c0HJBSeOTSgak',
  storage: 'supabase',
};
